import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  return (
    <motion.a
      href="https://api.whatsapp.com/send?phone=5511940447538&text=Olá! Gostaria de solicitar um orçamento."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 bg-green-500 text-white p-4 rounded-full shadow-2xl hover:bg-green-600 transition-all duration-300"
      initial={{ scale: 0, y: 100 }}
      animate={{
        scale: 1,
        y: 0,
        transition: {
          type: "spring",
          stiffness: 260,
          damping: 20,
          delay: 1
        }
      }}
      whileHover={{
        scale: 1.1,
        y: -5,
        transition: { duration: 0.2 }
      }}
      whileTap={{ scale: 0.95 }}
      style={{
        animation: 'float 3s ease-in-out infinite'
      }}
      aria-label="Fale conosco no WhatsApp"
    >
      <FaWhatsapp size={32} />
    </motion.a>
  );
};

export default WhatsAppButton;
